const state = {
    selectedCompany: null,//stores the selected client(used in form modal)
    formCompany: null,
    companyShow: false, //show=true | edit=false
    showCompanyModal: false,//controls if the form modal is displayed or not
    showCompanyUsersModal: false,//controls if the form modal is displayed or not
    // companies: []
};

const getters = {
    getSelectedCompany(state, getters){
        if(!state.selectedCompany){
            state.selectedCompany = getters.getNewCompany;
        }
        return state.selectedCompany;
    },
    getFormCompany(state, getters){
        if(!state.formCompany){
            state.formCompany = getters.getEmptyFormCompany;
        }
        return state.formCompany;
    },
    getCompanyShow(state){
        return state.companyShow;
    },
    getShowCompanyModal(state){
        return state.showCompanyModal;
    },
    getShowCompanyUsersModal(state){
        return state.showCompanyUsersModal;
    },


    getNewCompany(){
        return {
            id: '',
            name: '',
            types_company_type: null,
            types_company_types_id: '',
            types_company_categories_id: '',
            nib_bi_name: '',
            nib_bi: '',
            nib_bi2_name: '',
            nib_bi2: '',
            nif: '',
            state: '',
            countries_id: '',
            cities_id: '',
            address: '',
            active_state: '',
            contacts_json: [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}],
            description: '',
            fiscal_area_code: '',
            admin_user: {
                name: '',
                bi: '',
                email: '',
                password: ''
            },
            created_at: '',
        };
    },

    getEmptyFormCompany(){
        return {
            id: '',
            name: '',
            types_company_types_id: '',
            types_company_categories_id: '',
            nib_bi_name: '',
            nib_bi: '',
            nib_bi2_name: '',
            nib_bi2: '',
            nif: '',
            active_state: '',
            countries_id: '',
            cities_id: '',
            address: '',
            fiscal_area_code: '',
            contacts_json: [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}],
            admin_user: {
                name: '',
                bi: '',
                email: '',
                password: ''
            }
        }
    }

};

const mutations = {
    setSelectedCompany(state, payload){ //this also works for new company
        state.selectedCompany = payload;
    },
    setFormCompany(state, payload){
        state.formCompany = payload;
    },
    setPreparedFormCompany(state, payload){
        if(!payload) return;
        let array = [];
        if(payload.contacts_json){
            array = payload.contacts_json instanceof Array ? array = payload.contacts_json : JSON.parse(payload.contacts_json)
        }

        state.formCompany = {
            id: payload ? payload.id : '',
            name: payload ? payload.name : '',
            types_company_types_id: payload ? payload.types_company_types_id : '',
            types_company_categories_id: payload ? payload.types_company_categories_id : '',
            nib_bi: payload ? payload.nib_bi : '',
            nib_bi_name: payload ? payload.nib_bi_name : '',
            nib_bi2: payload ? payload.nib_bi2 : '',
            nib_bi2_name: payload ? payload.nib_bi2_name : '',
            nif: payload ? payload.nif : '',
            active_state: payload ? payload.active_state : 0,
            countries_id: payload ? payload.countries_id : '',
            cities_id: payload ? payload.cities_id : '',
            address: payload ? payload.address : '',
            fiscal_area_code: payload ? payload.fiscal_area_code : '',
            contacts_json: payload ? Array.from(array) : [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}],
            admin_user: {
                name: payload && payload.admin_user ? payload.admin_user.name : '',
                bi: payload && payload.admin_user ? payload.admin_user.bi : '',
                email: payload && payload.admin_user ? payload.admin_user.email : '',
                password: payload && payload.admin_user ? payload.admin_user.password : '',
            }
        };
    },
    setCompanyShow(state, payload){ //this also works for new company
        state.companyShow = payload;
    },
    setShowCompanyModal(state, payload){
        state.showCompanyModal = payload;
    },
    setShowCompanyUsersModal(state, payload){
        state.showCompanyUsersModal = payload;
    },
};

const actions = {
    setSelectedCompany( {commit}, payload){
        commit('setSelectedCompany', payload);
        commit('setPreparedFormCompany', payload);
    },
    setFormCompany( {commit}, payload){
       commit('setFormCompany', payload);
    },
    setCompanyShow({commit}, payload){
        commit('setCompanyShow', payload);
    },
    setShowCompanyModal({commit}, payload){
        commit('setShowCompanyModal', payload);
    },
    setShowCompanyUsersModal({commit}, payload){
        commit('setShowCompanyUsersModal', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};